import create from 'zustand';
export var useEdgeworthLocalDocumentsStore = create(function (set) { return ({
    localDocuments: undefined,
    setLocalDocuments: function (docs) {
        set({ localDocuments: docs });
    },
}); });
//# sourceMappingURL=useEdgeworthLocalDocumentsStore.js.map